export default {
	primary: '#00cc00'
}


// WEBPACK FOOTER //
// ./src/themes/limegreenTheme.js